module.exports = __webpack_public_path__ + "assets/all_data_primary.b0d23675.svg";